<template>
  <div class="oil">
    <img :style="{ height:bannerHeight+'px' }" @click="toOneCallOil" :src="`${$ossUrl}image/activePage/oneKeyToOil/oneKey.png`" alt="">
  </div>
</template>
<script>
import mixin from '../mixin'
export default {
  mixins: [mixin],
  data () {
    return {
      screenWidth :0,
      fixedHeight: 140,
      bannerHeight: 185,
    }
  },
  mounted () {
    this.fixedHeight = this.bannerHeight
    this.screenWidth =  window.innerWidth
    this.setSize()
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth =  window.innerWidth
      this.setSize()
    }
  },
  methods: {
    setSize () {
      // 通过浏览器宽度(图片宽度)计算高度
      if(this.screenWidth < 1200) return
      this.bannerHeight = this.fixedHeight / 1950 * this.screenWidth
    },
    toOneCallOil () {
      this.$track.clickEvent('一键叫油-图片', 1636083572)
      this.getChainToken()
    }
  }
}
</script>
<style scoped lang="less">
.oil{
  >img{
    display: block;
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>